module.exports = girder_plugin_worker;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_worker"
// module id = 70
// module chunks = 0